import { forwardRef, type InputHTMLAttributes } from "react";

interface AuthFloatingFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "placeholder"> {
  label: string;
  error?: string;
}

export const AuthFloatingField = forwardRef<HTMLInputElement, AuthFloatingFieldProps>(
  ({ label, error, id, className = "", ...props }, ref) => {
    const fieldId = id || `field-${label.toLowerCase().replace(/\s+/g, "-")}`;
    return (
      <div className={`gfg-field ${error ? "is-invalid" : ""} ${className}`}>
        <input ref={ref} id={fieldId} placeholder=" " autoComplete="off" {...props} />
        <label htmlFor={fieldId}>{label}</label>
        {error && <div className="gfg-field-error">{error}</div>}
      </div>
    );
  },
);
AuthFloatingField.displayName = "AuthFloatingField";
